<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17ahetN/tc-custom/9780310340454.jpg?1704825515029" alt="This image is the cover for the book Have More Fun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Have More Fun
      </h1>
      <p class="bookDescription body article font2">
        <p><b>When was the last time you had some good and serious <i>fun? </i>If your to-do list has become the boss of you, if you're so exhausted and overwhelmed you can't remember--all of that is about to change. <i>Have More Fun </i>is your crash course to getting unstuck, laughing freely, and enjoying the ride.</b></p><p>MOPS International CEO, Mandy Arioto, is known to thousands worldwide as a lively storyteller, a force of hope, and an audacious risk-taker. She brings it all in this rollicking adventure of an audiobook bent on helping you do more of what makes you come alive.</p><p><i>Have More Fun</i> is for anyone who has forgotten that fun is an option. In a world where political dramas and cultural uncertainties churn through our news feed every day, Mandy is here to suggest that the answer to many of the most pressing questions is fun.</p>How do I get more done? Fun.How do I parent in meaningful ways? Fun.How do I make friends? Fun.How can I find my purpose? Fun.How do I spice up my sex life? Fun.How do I adapt when things don't go as planned? Fun.How do I improve my marriage? Fun.<p>Not to mention that choosing fun can be a spiritual discipline--a place to experience the boundless love and joy of God in everyday, surprising ways. If you have ever waited until your to-do list is finished to have fun or you can't remember the last time you really laughed, it is possible you might be taking life, work, or parenting too seriously. Weaving together science, historical trends, hilarious stories, practical ideas and spiritual truth, Mandy uncovers fresh ways to take fun seriously instead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mandy Arioto, Bob Goff
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3148cc74